import { getGrowthStandardTempSuccess } from "features/growthStandardTempSlice";
import { call, put, takeLatest } from "redux-saga/effects";
import { DELETE, GET, PATCH, POST, PUT } from "services/ServiceBase";
import ServiceURL from "services/ServiceURL";
import { ActionType } from "type";
import _ from "lodash";

export function* getGrowthStandardTemps(data: ActionType): any {
  const { callback, body, query, skipUpdateReducer } = data.payload;
  const url = `${ServiceURL.growthStandardTemps}?${query ?? ""}`;
  try {
    const res = yield call(GET, url, body);
    if (!!res?.code && !!res?.message) {
      callback.failed(res?.message);
    } else {
      if (!skipUpdateReducer)
        yield put(getGrowthStandardTempSuccess(_.get(res, "data", {})));
      callback.success(_.get(res, "data", {}));
    }
  } catch (error: any) {
    const err = error?.response?.data?.message || error?.message;
    callback.failed(err);
  }
}

export function* createGrowthStandardTemp(data: ActionType): any {
  const { callback, body } = data.payload;
  const url = ServiceURL.growthStandardTemps;
  try {
    const res = yield call(POST, url, body);
    if (!!res?.response?.data?.code && !!res?.response?.data?.message) {
      callback.failed(res?.response?.data?.message);
    } else {
      callback.success(_.get(res, "data", {}));
    }
  } catch (error: any) {
    const err = error?.response?.data?.message || error?.message;
    callback.failed(err);
  }
}

export function* updateGrowthStandardTemp(data: ActionType): any {
  const { callback, body, params } = data.payload;
  const url = `${ServiceURL.growthStandardTemps}/${params}`;
  try {
    const res = yield call(PATCH, url, body);
    if (!!res?.response?.data?.code && !!res?.response?.data?.message) {
      callback.failed(res?.response?.data?.message);
    } else {
      callback.success(_.get(res, "data", {}));
    }
  } catch (error: any) {
    const err = error?.response?.data?.message || error?.message;
    callback.failed(err);
  }
}
export function* deleteGrowthStandardTemp(data: ActionType): any {
  const { callback, body, params } = data.payload;
  const url = `${ServiceURL.growthStandardTemps}/${params}`;
  try {
    const res = yield call(DELETE, url, body);
    if (res.data?.error?.message) {
      callback.failed(res.data?.error?.message);
    } else {
      callback.success(res);
    }
  } catch (error: any) {
    const err = error?.response?.data?.message || error?.message;
    callback.failed(err);
  }
}

export default function* growthStandardTempSaga() {
  yield takeLatest(
    "growthStandardTempSlice/getGrowthStandardTemps",
    getGrowthStandardTemps
  );
  yield takeLatest(
    "growthStandardTempSlice/createGrowthStandardTemp",
    createGrowthStandardTemp
  );
  yield takeLatest(
    "growthStandardTempSlice/updateGrowthStandardTemp",
    updateGrowthStandardTemp
  );
  yield takeLatest(
    "growthStandardTempSlice/deleteGrowthStandardTemp",
    deleteGrowthStandardTemp
  );
}
